import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70428990&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=70428990&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70428990",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70428990')) {
      api.createRecord('70428990', component.options)
    } else {
      api.reload('70428990', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70428990&scoped=true&lang=pug", function () {
      api.rerender('70428990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/serviceIntroduction/material/index.vue"
export default component.exports